import {
  SET_LOADING,
  RESET_LOADING,
  GET_MY_PLAYLISTS,
  GET_PLAYLISTS,
} from "../types";
import { auth, firestore } from "../../firebase";
import UIkit from "uikit";
import { closeModal } from "../../utils/index";
import { Dispatch } from "redux";
import { Track } from "../../models/track";
import { Playlist } from "../../models/playlist";

export const createPlaylistTitle = (payload: {
  title: string;
  tag: string;
  available: string;
  selected: Track | null | undefined;
  username: string;
}) => async (dispatch: Dispatch) => {
  dispatch({
    type: SET_LOADING,
  });
  closeModal(`playlists-modal`);
  try {
    let user = auth.currentUser;
    if (!user) {
      return UIkit.modal.dialog(
        `<p class="uk-modal-body">Login to use this feature</p>`
      );
    }
    if (payload) {
      const { title, tag, available, selected, username } = payload;
      let playlist: Playlist;

      if (selected && selected.title !== "") {
        playlist = {
          title,
          tag,
          public: available === "public",
          user: { id: user.uid, username },
          tracks: [selected],
        };
      } else {
        playlist = {
          title,
          tag,
          public: available === "public",
          user: { id: user.uid, username: username },
          tracks: [],
        };
      }

      await firestore.collection("playlist").add(playlist);
    }
  } catch (error) {
    console.log(error);
  } finally {
    dispatch({
      type: RESET_LOADING,
    });
  }
};

export const getPlaylists = () => async (dispatch: Dispatch) => {
  try {
    await firestore.collection("playlist").onSnapshot((snap) => {
      let playlists: Playlist[] = [];
      if (!snap.empty) {
        snap.forEach((doc) => {
          let playlist = doc.data();
          let p: Playlist = {
            id: doc.id,
            user: doc.data().user,
            tracks: doc.data().tracks,
            title: doc.data().title,
            public: doc.data().public,
            tag: doc.data().tag,
          };
          playlist.id = doc.id;
          playlists = [...playlists, p];
        });

        dispatch({
          type: GET_PLAYLISTS,
          payload: playlists,
        });
      } else {
        dispatch({
          type: GET_PLAYLISTS,
          payload: [],
        });
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const getMyPlaylists = (username: string) => async (
  dispatch: Dispatch
) => {
  dispatch({
    type: SET_LOADING,
  });
  let usr = auth.currentUser;
  if (!usr) {
    dispatch({ type: RESET_LOADING });
    return null;
  }
  try {
    if (usr === null || usr === undefined) {
      dispatch({
        type: RESET_LOADING,
      });
      return;
    }
    let user = {
      id: usr.uid,
      username,
    };

    firestore
      .collection("playlist")
      .where("user", "==", user)
      .onSnapshot((snap) => {
        let myplays: Playlist[] = [];
        if (!snap.empty) {
          snap.forEach((doc) => {
            let plist = doc.data();
            let p: Playlist = {
              public: plist.public,
              id: doc.id,
              tag: plist.tag,
              title: plist.title,
              tracks: plist.tracks,
              user: plist.user,
            };
            plist.id = doc.id;
            myplays = [...myplays, p];
          });
        }

        dispatch({
          type: GET_MY_PLAYLISTS,
          payload: myplays,
        });
      });
  } catch (error) {
    console.log(`playlist ${error}`);
  } finally {
    dispatch({
      type: RESET_LOADING,
    });
  }
};

export const addToPlaylist = (payload: {
  selected: Track;
  id: string;
}) => async (dispatch: Dispatch) => {
  closeModal(`playlists-modal`);
  dispatch({
    type: SET_LOADING,
  });
  try {
    let user = auth.currentUser;
    let { selected } = payload;
    if (!user) {
      return UIkit.modal.dialog(
        `<p class="uk-modal-body">Login to use this feature</p>`
      );
    }
    if (!selected) {
      return UIkit.modal.dialog(
        `<p class="uk-modal-body">Error adding to playlist </p>`
      );
    }
    let resp;
    let ref = firestore.collection("playlist").doc(payload.id);
    let doc = await ref.get();
    let playlist = doc.data();
    if (!playlist?.tracks.includes(selected)) {
      resp = await ref.update({ tracks: [...playlist?.tracks, selected] });
    }
    console.log(resp);
  } catch (error) {
    console.log(error);
  } finally {
    // dispatch({
    //   type: ADD_TO_PLAYLIST,
    //   payload
    // })
    dispatch({
      type: RESET_LOADING,
    });
  }
};

export const deletePlaylist = (pid: string, uid: string) => async (
  dispatch: Dispatch
) => {
  try {
    const user = auth.currentUser;
    if (user?.uid !== uid) {
      return UIkit.modal.dialog(
        `<p class="uk-modal-body">Unauthorized action</p>`
      );
    } else {
      await firestore.collection("playlist").doc(pid).delete();
    }
  } catch (error) {
    console.log(error);
    return UIkit.modal.dialog(
      `<p class="uk-modal-body">Unauthorized action</p>`
    );
  }
};
